import { Tabs } from './enums';

export const addRouteChangeListener = (callback: () => void):void => {
  let oldUrl = window.location.href;

  const checkURLchange = () => {
    if (oldUrl !== window.location.href) {
      callback();
      oldUrl = window.location.href;
    }
  };

  setInterval(checkURLchange, 500);
};

export const formatTab = (tab: Tabs, id?: string): string => tab + (id ? `_${id}` : '');
